import React, { Component } from 'react';
import { Button, Card, Col, Drawer, Form, Input, InputNumber, Radio, Row } from 'antd';
import { connect } from 'react-redux';
import SearchUser from '@comm/SearchUser';
import { getAccountSearch } from '@store/modules/core_account_search';
import './drawer.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class ActivityAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processorType: 0,
      timeOutFlag: 0,
      isMultiple: '',
    };
  }

  componentWillMount() {
    this.setState({
      processorType: this.props.activity.processorType,
      timeOutFlag: this.props.activity.timeOutFlag,
    });
  }

  componentDidMount() {
    let isMultiple = '';
    const { activity } = this.props;
    this.props.dispatch(getAccountSearch());
    if (activity.type === 1 || activity.type === 2) {
      isMultiple = 'multiple';
    }
    this.setState({
      processorType: activity.processorType,
      timeOutFlag: activity.timeOutFlag,
      isMultiple,
    });
  }

  componentWillReceiveProps(nextProps) {
    let isMultiple = '';
    if (nextProps.activity.processorType === this.props.activity.processorType) {
      return;
    }
    if (nextProps.activity.type === 1 || nextProps.activity.type === 2) {
      isMultiple = 'multiple';
    }
    this.setState({
      processorType: nextProps.activity.processorType,
      timeOutFlag: nextProps.activity.timeOutFlag,
      isMultiple,
    });
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { addActivity, activity } = this.props;
    const permis = this.props.form.getFieldsValue();
    let str = '';
    if (permis.type === 0) {
      if (permis.type === 1 || permis.type === 2) {
        permis.processor.map(item => {
          str = `${str + item},`;
          return 1;
        });
        str = str.substring(0, str.length - 1);
        permis.processor = str;
      } else {
        Array.isArray(permis.processor) && (permis.processor = permis.processor[0]);
      }
    }

    if (activity && activity.uuid) {
      permis.uuid = activity.uuid;
    }
    permis.index = activity.index;
    this.props.form.validateFields(err => {
      if (!err) {
        addActivity(permis);
        // this.props.form.resetFields();
      }
    });
  };

  onChange = e => {
    const { name, value } = e.target;
    const params = {};
    params[name] = value;
    this.setState({
      ...params,
    });
  };

  changeType = e => {
    if (e.target.value === 1 || e.target.value === 2) {
      this.setState({
        isMultiple: 'multiple',
      });
    } else {
      this.setState({
        isMultiple: '',
      });
    }

    return e.target.value;
  };

  onChangeProcessor = () => {};

  render() {
    const { getFieldDecorator } = this.props.form;
    const { deleteActivity, closeDrawer, visible, activity } = this.props;
    let { processor } = activity;
    const { processorType, timeOutFlag, isMultiple } = this.state;
    const ItemLayout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
    };
    !Array.isArray(processor) && processor && (processor = processor.split(','));
    const element =
      isMultiple === '' ? (
        <SearchUser
          isMultiple={this.state.isMultiple}
          onChange={() => {
            this.onChangeProcessor();
          }}
        />
      ) : (
        <SearchUser
          isMultiple={this.state.isMultiple}
          onChange={() => {
            this.onChangeProcessor();
          }}
        />
      );
    return (
      <Drawer
        title="活动详情"
        placement="right"
        width={720}
        onClose={closeDrawer}
        visible={visible}
        className="template-drawer"
      >
        <Form onSubmit={this.submit}>
          <Card>
            <Row>
              <Col>
                <FormItem label="活动名称" {...ItemLayout}>
                  {getFieldDecorator('name', {
                    rules: [{ required: true, message: '请输入活动名称 !' }],
                    initialValue: activity.name ? activity.name : '',
                  })(<Input placeholder="活动名称" />)}
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col>
                <FormItem label="活动条件" {...ItemLayout}>
                  {getFieldDecorator('condition', {
                    initialValue: activity.condition ? activity.condition : '',
                  })(<Input placeholder="活动条件" />)}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem label="活动类型" {...ItemLayout}>
                  {getFieldDecorator('type', {
                    rules: [{ required: true, message: '请输入活动类型 !' }],
                    initialValue: activity.type ? activity.type : 0,
                    getValueFromEvent: this.changeType,
                  })(
                    <RadioGroup name="type">
                      <Radio value={0}>依次审批 (本环节内审批人依次审批)</Radio>
                      <Radio value={1}>会签 (须所有审批人同意)</Radio>
                      <Radio value={2}>或签 (一名审批人同意或拒绝即可)</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormItem label="操作人类型" {...ItemLayout}>
                  {getFieldDecorator('processorType', {
                    rules: [{ required: true, message: '请选择操作人类型 !' }],
                    initialValue: activity.processorType ? activity.processorType : 0,
                  })(
                    <RadioGroup name="processorType" onChange={this.onChange}>
                      <Radio value={0}>指定成员</Radio>
                      <Radio value={1}>变量获取</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem label="操作人" {...ItemLayout}>
                  {getFieldDecorator('processor', {
                    rules: [{ required: true, message: '请选择操作人 !' }],
                    initialValue: processor || '',
                  })(processorType ? <Input /> : element)}
                </FormItem>
              </Col>
              <Col>
                <FormItem label="是否设超时标识" {...ItemLayout}>
                  {getFieldDecorator('timeOutFlag', {
                    rules: [
                      {
                        required: true,
                        message: '请选择是否设置超时操作标识 !',
                      },
                    ],
                    initialValue: activity.timeOutFlag ? activity.timeOutFlag : 0,
                  })(
                    <RadioGroup name="timeOutFlag" onChange={this.onChange}>
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
              <Col>
                {timeOutFlag ? (
                  <FormItem label="超时时间" {...ItemLayout}>
                    {getFieldDecorator('timeOut', {
                      rules: [{ required: true, message: '请设置超时时间 !' }],
                      initialValue: activity.timeOut ? activity.timeOut : 0,
                    })(<InputNumber />)}
                  </FormItem>
                ) : null}
              </Col>
              <Col>
                <FormItem label="超时操作" {...ItemLayout}>
                  {getFieldDecorator('timeOutHandler', {
                    rules: [
                      {
                        required: true,
                        message: '请选择是否设置超时操作标识 !',
                      },
                    ],
                    initialValue: activity.timeOutHandler ? activity.timeOutHandler : 0,
                  })(
                    <RadioGroup name="timeOutHandler" onChange={this.onChange}>
                      <Radio value={0}>不操作</Radio>
                      <Radio value={1}>超时自动提交</Radio>
                      <Radio value={2}>超时自动打回</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem label="是否禁止打回" {...ItemLayout}>
                  {getFieldDecorator('isBanReturn', {
                    rules: [{ required: true, message: '请选择是否是否禁止打回 !' }],
                    initialValue: activity.timeOutFlag ? activity.timeOutFlag : 0,
                  })(
                    <RadioGroup name="timeOutFlag" onChange={this.onChange}>
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem label="是否通知" {...ItemLayout}>
                  {getFieldDecorator('notification', {
                    rules: [{ required: true, message: '请选择是否通知 !' }],
                    initialValue: activity.notification ? activity.notification : 0,
                  })(
                    <RadioGroup name="notification" onChange={this.onChange}>
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
              <Col>
                <FormItem label="是否去重复" {...ItemLayout}>
                  {getFieldDecorator('deduplication', {
                    rules: [{ required: true, message: '请选择是否去重复 !' }],
                    initialValue: activity.deduplication ? activity.deduplication : 0,
                  })(
                    <RadioGroup name="deduplication">
                      <Radio value={1}>是</Radio>
                      <Radio value={0}>否</Radio>
                    </RadioGroup>,
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row />
            <Row>
              <Col>
                <Button htmlType="submit" icon="save" style={{ marginRight: 10 }}>
                  保存
                </Button>
                <Button
                  icon="delete"
                  style={{ marginRight: 10 }}
                  onClick={() => deleteActivity(activity)}
                >
                  删除节点
                </Button>
                <Button icon="cancel" style={{ marginRight: 10 }} onClick={closeDrawer}>
                  取消
                </Button>
              </Col>
            </Row>
          </Card>
        </Form>
      </Drawer>
    );
  }
}

export default connect(state => state)(Form.create({ wrappedComponentRef: true })(ActivityAdd));



// WEBPACK FOOTER //
// ./src/components/boss/workflow/template/ActivityAdd.js